import {Dimension, START} from '../abstract-units';
import {Edge} from '../edge';
import {EdgeWalker} from './edge-walker';

export class AxisEdgesWalker {

    constructor(
        public edges: Edge[],
        public axis: Dimension
    ) {}

    public first(): EdgeWalker {
        const firstEdge: Edge = this.edges[START];

        return new EdgeWalker(firstEdge || null);
    }

    public last(): EdgeWalker {
        const edgeCount = this.edges.length;
        const lastEdge: Edge = edgeCount ? this.edges[edgeCount - 1] : null;

        return new EdgeWalker(lastEdge);
    }

    public middle(): AxisEdgesWalker {
        const edges: Edge[] = this.edges.slice(1, this.edges.length - 1);

        return new AxisEdgesWalker(edges, this.axis);
    }

    public find(predicate: (edge: Edge) => boolean): EdgeWalker {
        const edge: Edge = this.edges.find(predicate);

        return new EdgeWalker(edge);
    }
}
